
import {Component, Vue} from "vue-property-decorator";
import QueryOverviewTable from "@/components/query/overview/QueryOverviewTable.vue";

@Component({
  components: {QueryOverviewTable}
})
export default class QueryOverview extends Vue {

}
